import '@/assets/css/main.css'

import { createApp, watch } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import { i18n, LOCALE_STORAGE_KEY } from './i18n'

console.log(`Application version: ${import.meta.env.VITE_APP_VERSION}`)

const app = createApp(App)

watch(i18n.global.locale, (locale) => localStorage.setItem(LOCALE_STORAGE_KEY, locale))

app.use(createPinia())
app.use(router)
app.use(i18n)

app.mount('#app')
